import {
  CREATE_TEAM_FAILED,
  CREATE_TEAM_LOADING,
  CREATE_TEAM_SUCCESS,
  DELETE_TEAM_FAILED,
  DELETE_TEAM_LOADING,
  DELETE_TEAM_SUCCESS,
  INVITE_USER_FAILED,
  INVITE_USER_LOADING,
  INVITE_USER_SUCCESS,
  LOG_OUT,
  REMOVE_MEMBER_FAILED,
  REMOVE_MEMBER_LOADING,
  REMOVE_MEMBER_SUCCESS,
  TEAMS_FAILED,
  TEAMS_LOADING,
  TEAMS_SUCCESS
} from "../constants/actionTypes"

import type { ReducerAction, Team } from "../constants/types"

type TeamState = {
  isLoading: boolean
  teams: Team[]
}

const initialState: TeamState = {
  isLoading: false,
  teams: []
}

function deleteTeam(teams: Team[], id: string): Team[] {
  return teams.filter(t => t.id !== id)
}

export default function (state: TeamState = initialState, action: ReducerAction): TeamState {
  switch (action.type) {
    // =============================================================================
    case TEAMS_LOADING:
      return { ...state, isLoading: true }
    case TEAMS_SUCCESS: {
      const payload = action.payload as unknown
      const teams: Team[] = Array.isArray(payload) ? (payload as Team[]) : []
      return { ...state, isLoading: false, teams }
    }
    case TEAMS_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case CREATE_TEAM_LOADING:
      return { ...state, isLoading: true }
    case CREATE_TEAM_SUCCESS: {
      const created = action.payload as Team
      return { ...state, isLoading: false, teams: [...state.teams, created] }
    }
    case CREATE_TEAM_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case DELETE_TEAM_LOADING:
      return { ...state, isLoading: true }
    case DELETE_TEAM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        teams: deleteTeam(state.teams, action.payload as string)
      }
    case DELETE_TEAM_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case INVITE_USER_LOADING:
      return { ...state, isLoading: true }
    case INVITE_USER_SUCCESS:
      return { ...state, isLoading: false }
    case INVITE_USER_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case REMOVE_MEMBER_LOADING:
      return { ...state, isLoading: true }
    case REMOVE_MEMBER_SUCCESS:
      return { ...state, isLoading: false }
    case REMOVE_MEMBER_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case LOG_OUT:
      return initialState
    // =============================================================================
    default:
      break
  }
  return state
}
